import React from "react";

const EmptyState = ({ icon, heading, subtext, action }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center">
    {icon && (
      <div className="w-12 h-12 rounded-full bg-pageBg border border-cardBorder flex items-center justify-center mb-4 text-textMuted">
        {icon}
      </div>
    )}
    <p className="text-sm font-semibold text-textPrimary mb-1">{heading}</p>
    {subtext && <p className="text-xs text-textMuted mb-4">{subtext}</p>}
    {action}
  </div>
);

export default EmptyState;
